import React, { useEffect, useRef, useState } from 'react';
import Appearance from 'styles/Appearance.js';
import ProgressBar from 'views/ProgressBar.js';
import Utils from 'files/Utils.js';

const ListField = ({ autoOpenOnFocus = false, defaultValue, disabled, disablePlaceholder, items, loading, onAddNew, onAsyncChange, onChange, onFocus, placeholder, placeholderItem, preserveResult, returnKey, style, utils, value }) => {

    const ref = useRef(null);
    const [selected, setSelected] = useState(value);

    const onFocusChange = evt => {
        if(typeof(onFocus) === 'function') {
            onFocus(evt);
        }
        if(autoOpenOnFocus === true) {
            ref.current?.click();
        }
    }
    
    const onListChange = async evt => {
        try {

            // prepare item result using selected id from event
            let id = Utils.attributeForKey.select(evt, 'id');
            let match = items.find(item => item.id == id || item.code == id);
            console.log(match);

            // run async change function if applicable
            if(typeof(onAsyncChange) === 'function') {
                await onAsyncChange(match);
            }

            // update local state with selected item if applicable
            setSelected(preserveResult !== false && match ? (match.title || match.text) : null);

            // notify subscribers of data change if applicable
            if(typeof(onChange) === 'function') {
                if(!match) {
                    onChange(null);
                    return;
                }
                onChange(returnKey === false ? (match.title || match.text) : match);
            }

        } catch(e) {
            console.error(e.message);
            if(e.message !== 'user_cancelled') {
                utils.alert.show({
                    message: e.message,
                    title: 'Oops!'
                });
            }
        }
    }

    const getAccessoryButton = () => {
        if(typeof(onAddNew) === 'function') {
            return (
                <div style={{
                    flex: 'none',
                    height: 30,
                    marginLeft: 8,
                    width: 30
                }}>
                    <img
                    className={'text-button'}
                    src={'images/new-button-green-small.png'}
                    onClick={onAddNew}
                    style={{
                        height: '100%',
                        objectFit: 'contain',
                        width: '100%'
                    }} />
                </div>
            )
        }
        return null;
    }

    const getItems = () => {
        if(!items || !Array.isArray(items)) {
            return null;
        }
        return items.map((item, index) => {
            return (
                <option
                key={index}
                id={item.id || item.code}
                disabled={item.disabled || false}>{item.title || item.text}</option>
            )
        })
    }

    useEffect(() => {
        setSelected(value);
    }, [value]);

    return (
        <div style={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            ...style
        }}>
            <select
            className={`custom-select ${window.theme}`}
            defaultValue={defaultValue}
            disabled={disabled}
            onChange={onListChange}
            onFocus={onFocusChange}
            ref={ref}
            style={{
                background: `${Appearance.colors.textField()} url("images/custom-select-list-arrows-${window.theme === 'dark' ? 'white' : 'black'}.png") no-repeat right 0.75rem center`,
                backgroundSize: '10px',
                flexGrow: 1,
                height: 35
            }}
            value={selected || placeholder || ''}>
                {placeholderItem !== false && (
                    <option disabled={disablePlaceholder}>{placeholder || 'Choose from the list below...'}</option>
                )}
                {getItems()}
            </select>
            {loading === true && (
                <div style={{
                    borderRadius: 2,
                    bottom: 0,
                    overflow: 'hidden',
                    position: 'absolute',
                    height: 2,
                    left: 0,
                    right: 0
                }}>
                    <ProgressBar />
                </div>
            )}
            {getAccessoryButton()}
        </div>
    )
}

export default ListField;
